/*
 * The breadcrumb section's mobile overlay (sections/breadcrumb.liquid,
 * `overlay_mobile`; styled by assets/breadcrumb.css).
 *
 * The crumbs float over the gallery's first image and are meant to leave when
 * the customer swipes away from it, then slide back down on their return. The
 * two live in different sections, so there is no event to listen to — the
 * gallery's own Swiper instance is the only source of truth for which image is
 * active, and Swiper publishes it as `.swiper` on the element it initialised.
 *
 * `realIndex`, not `activeIndex`: the gallery runs in loop mode, where Swiper
 * duplicates slides at both ends and `activeIndex` counts those duplicates.
 * `realIndex` is the position in the merchant's own media list, which is what
 * "the first image" means.
 *
 * Without JavaScript the crumbs simply stay visible over the first image: the
 * overlay itself is CSS, so the fallback is a working breadcrumb that never
 * hides rather than a breadcrumb that never appears.
 */
(() => {
  const OVERLAY_SELECTOR = ".m-breadcrumb--overlay";
  const GALLERY_SELECTOR = ".m-media-gallery__inner";
  const INITIALISED_CLASS = "swiper-container-initialized";
  const HIDDEN_CLASS = "is-hidden";

  function bind(overlay) {
    const gallery = document.querySelector(GALLERY_SELECTOR);
    if (!gallery) return;

    const attach = () => {
      const swiper = gallery.swiper;
      if (!swiper) return false;

      const sync = () => overlay.classList.toggle(HIDDEN_CLASS, swiper.realIndex !== 0);
      sync();
      swiper.on("slideChange", sync);
      return true;
    };

    if (attach()) return;

    /* The gallery initialises itself after this script has run and says so by
       adding `swiper-container-initialized` — the same class the theme's own
       styles key on. Watching for that beats a timeout: nothing here has to
       guess how long initialisation takes, and a gallery that never initialises
       (no images, an error) simply leaves the crumbs in place. */
    const observer = new MutationObserver(() => {
      if (!gallery.classList.contains(INITIALISED_CLASS)) return;
      if (attach()) observer.disconnect();
    });
    observer.observe(gallery, { attributes: true, attributeFilter: ["class"] });
  }

  const start = () => {
    const overlay = document.querySelector(OVERLAY_SELECTOR);
    if (!overlay) return;
    bind(overlay);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
